export default __webpack_public_path__ + "static/media/image33.c5c617a2.png";